// client/src/components/CookieConsentBanner.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const location = useLocation();

  // Public pages where cookie banner should not appear
  const publicRoutes = [
    '/',
    '/login',
    '/register',
    '/forgot-password',
    '/privacy-policy',
    '/terms-of-service',
    '/blog',
  ];

  const isPublicPage = (pathname) => {
    // Check exact matches first
    if (publicRoutes.includes(pathname)) {
      return true;
    }
    // Check for routes with parameters
    if (pathname.startsWith('/reset-password/')) return true;
    if (pathname.startsWith('/quotes/public/')) return true;
    if (pathname.startsWith('/invoices/public/')) return true;
    if (pathname.startsWith('/book/')) return true;
    if (pathname.startsWith('/estimate-software/')) return true;
    if (pathname.startsWith('/blog/')) return true;
    return false;
  };

  useEffect(() => {
    // Don't show banner on public pages
    if (isPublicPage(location.pathname)) {
      setShowBanner(false);
      return;
    }

    // Check if user has already accepted/rejected cookies
    const cookieConsent = localStorage.getItem('cookieConsent');

    // Only show banner if no consent decision has been made
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, [location.pathname]);

  const handleOK = () => {
    localStorage.setItem('cookieConsent', 'acknowledged');
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 sm:p-6 z-50">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <h3 className="font-semibold mb-2">Cookie Policy</h3>
          <p className="text-sm text-gray-300">
            We use cookies to keep you logged in securely and provide a better experience.
            By using SwiftBidPro, you agree to our use of cookies.{' '}
            <a href="/privacy-policy" className="text-primary-400 hover:text-primary-300 underline">
              Learn more
            </a>
          </p>
        </div>

        <div className="flex gap-3 shrink-0">
          <button
            onClick={handleOK}
            className="px-4 py-2 text-sm font-medium bg-primary-600 hover:bg-primary-700 rounded-md transition text-white"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
